import React from "react"

export const ButtonLoading = () => {
  return (
    <div>
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}
